export default __webpack_public_path__ + "static/media/3.dbd759d8.png";